import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';

export function AccordionHeader({ children, className, ...divProps }: PropsWithChildren<DivProps>) {
  return (
    <div {...divProps} className={appendClassName(className, 'accordion__item-wrapper')}>
      {children}
    </div>
  );
}
